import React from "react";

const Terms = () => {
  return (
    <div className="text-center mt-5">
      <h1>Terms</h1>
    </div>
  );
};

export default Terms;
